import { warning } from "@phonero/pux-icons/icons"
import { PuxButton, PuxIcon, toaster } from "@phonero/pux-react"
import { CancelPaymentDocument, useAppTranslations } from "@phonero/common-ux"
import { routes } from "../../routes"
import { Link, matchPath, useLocation } from "react-router-dom"
import css from "./styles.module.scss"
import { useMutation } from "@apollo/client"
import { PaymentMethod, PaymentOperation } from "@phonero/common-graphql/types"
import { createRoutePath } from "../../util/createRoutePath"
import { useOutstandingPayments } from "../../util/useOutstandingPayments"

const OutstandingPayments = () => {
  const {
    purchases,
    remove,
    outstanding,
    firstOutstanding: first,
    count,
  } = useOutstandingPayments()
  const location = useLocation()
  const { t } = useAppTranslations()

  const color = "primary"

  const paymentMethod = first?.paymentMethod

  const [cancel, _cancelResult] = useMutation(CancelPaymentDocument, {
    onError: (d) => toaster.error(d.message),
    onCompleted: (d) => {
      if (d.cancelPayment.errors) {
        toaster.error(
          "Det oppstod en feil: " +
            d.cancelPayment.errors.map((err) => err.message).join(" - ")
        )
        return
      }
      const lastOp =
        d.cancelPayment.cancelPaymentResponse?.vippsPaymentDetails?.lastState
          ?.operation
      if (!lastOp) {
        toaster.error("Beklager, det oppstod en feil, manglende status")
        return
      }
      switch (lastOp) {
        case PaymentOperation.Cancelled:
        case PaymentOperation.Void:
          toaster.success("Ordren ble kansellert")
          d.cancelPayment.cancelPaymentResponse?.vippsPaymentDetails?.id &&
            remove(
              d.cancelPayment.cancelPaymentResponse?.vippsPaymentDetails?.id
            )
          break
        default:
          toaster.error(
            "Beklager, det oppstod en feil, uventet status: " + lastOp
          )
          return
      }
    },
  })
  if (!purchases || Object.keys(purchases).length === 0) {
    return null
  }
  if (!first) {
    return null
  }

  const isOnPaymentCallbackPage = matchPath(location.pathname, {
    path: routes.paymentCallbackVipps.path,
  })

  const isOnPaymentCallbackRecurringPage = matchPath(location.pathname, {
    path: routes.paymentCallbackVippsRecurring.path,
  })

  if (window.Cypress) {
    return null
  }
  if (!!isOnPaymentCallbackPage || !!isOnPaymentCallbackRecurringPage) {
    return null
  }

  function onCancel() {
    if (!first) {
      return
    }
    cancel({
      variables: {
        input: {
          paymentId: first.paymentID,
          paymentMethod: first.paymentMethod,
        },
      },
    })
    remove(first.paymentID)
  }

  return (
    <div
      className={css.container}
      {...(_IS_DEV && {
        title: JSON.stringify(outstanding, null, 2),
      })}
      style={{
        background: `var(--pux-color-${color})`,
        color: `var(--pux-color-${color}-contrast)`,
      }}
    >
      <div>
        <PuxIcon icon={warning} />
      </div>
      <div>
        {t("PaymentCallBack.BannerText", {
          context: count === 1 ? "single" : "multiple",
          count: count,
          mdInline: false,
          ...first,
        })}
      </div>
      <div className={css.buttons}>
        <Link
          to={
            createCallBackPageUrl(first.paymentID, paymentMethod)
          }
        >
          <PuxButton fill="solid" color="light" shape="round" size="small" onClick={() => {  window.location.href = first?.paymentURI! }}>
            Gå til vipps
          </PuxButton>
        </Link>
        {paymentMethod === PaymentMethod.Vipps && <PuxButton
          fill="outline"
          color="light"
          shape="round"
          size="small"
          onClick={onCancel}
        >
          Avbryt
        </PuxButton>}
      </div>
    </div>
  )
}

function createCallBackPageUrl(
  paymentID: string,
  paymentMethod: PaymentMethod
) {
  switch (paymentMethod) {
    case PaymentMethod.Vippsrecurring:
      return createRoutePath("paymentCallbackVippsRecurring", {
        paymentID: paymentID,
      }).path
    case PaymentMethod.Vipps:
      return createRoutePath("paymentCallbackVipps", {
        paymentID: paymentID,
      }).path
    default:
      return ""
  }
}
export default OutstandingPayments
